__turbopack_context__.v({
  "actionButton": "professional-card-module__4BKjuq__actionButton",
  "callButton": "professional-card-module__4BKjuq__callButton",
  "detailItem": "professional-card-module__4BKjuq__detailItem",
  "distanceBadge": "professional-card-module__4BKjuq__distanceBadge",
  "distanceBadgeEstimated": "professional-card-module__4BKjuq__distanceBadgeEstimated",
  "mapsButton": "professional-card-module__4BKjuq__mapsButton",
  "professionalActions": "professional-card-module__4BKjuq__professionalActions",
  "professionalCard": "professional-card-module__4BKjuq__professionalCard",
  "professionalDetails": "professional-card-module__4BKjuq__professionalDetails",
  "professionalHeader": "professional-card-module__4BKjuq__professionalHeader",
  "professionalInfo": "professional-card-module__4BKjuq__professionalInfo",
  "professionalLastName": "professional-card-module__4BKjuq__professionalLastName",
  "professionalName": "professional-card-module__4BKjuq__professionalName",
  "professionalNumber": "professional-card-module__4BKjuq__professionalNumber",
  "selectedCard": "professional-card-module__4BKjuq__selectedCard",
});
